import {
    FGIcons,
    FGStack,
    FGStackItem,
    FGTile,
    FGTypography,
} from '@fg/design-system';
import { E_RISK_TYPE } from 'interfaces';
import { inject } from 'mobx-react';
import cx from 'classnames';
import { IMobxRootState } from 'RootStore';
import { RISK_TYPE_TO_LABEL } from 'utils/riskUtils';

const RISK_TYPE_TO_ICON = {
    [E_RISK_TYPE.DIMENSIONS]: 'DisplayAsRows',
    [E_RISK_TYPE.CLIENT_FACING_INDICATORS]: 'Screener',
};
const HeatmapRiskSelection = inject(({ heatmapStore }: IMobxRootState) => {
    return {
        currentRiskType: heatmapStore.riskType,
        heatmapStore,
    };
})(({ heatmapStore, currentRiskType }: any) => {
    const setRiskType = async (newRiskType: E_RISK_TYPE) => {
        if (newRiskType === currentRiskType) {
            return;
        }
        heatmapStore.setRiskType(newRiskType);
    };
    return (
        <FGStackItem>
            <FGStack gap={8} direction="column">
                {[
                    E_RISK_TYPE.DIMENSIONS,
                    E_RISK_TYPE.CLIENT_FACING_INDICATORS,
                ].map(riskType => (
                    <FGTile
                        key={riskType}
                        padding="small"
                        className={cx('button', {
                            active: riskType === currentRiskType,
                        })}
                        appearance="secondary"
                        onClick={() => setRiskType(riskType)}>
                        <FGStack gap={8}>
                            {/* @ts-ignore*/}
                            <FGIcons icon={RISK_TYPE_TO_ICON[riskType]} />
                            <FGTypography tag="label" variant="label2">
                                {RISK_TYPE_TO_LABEL[riskType]}
                            </FGTypography>
                        </FGStack>
                    </FGTile>
                ))}
            </FGStack>
        </FGStackItem>
    );
});

export default HeatmapRiskSelection;
